
import { getRequestLanguage } from '@/api/utils'
import { NavBar } from 'vant'
import { reactive, toRefs, onMounted, Ref, PropType, getCurrentInstance, ComponentInternalInstance, computed } from 'vue'

interface MNavBarState {
  isSlotLeft: Ref<boolean>
  isSlotRight: Ref<boolean>
  handleClose: () => void
  language: Ref<string>
}

export default {
  name: 'MNavBar',
  components: {
    NavBar
  },
  props: {
    title: {
      type: String as PropType<string>,
      default: '标题'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: false
    },
    closeable: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup(props: Readonly<{
    onClose?: () => void
  }>): MNavBarState {
    const { slots } = getCurrentInstance() as ComponentInternalInstance
    const state = reactive({
      isSlotLeft: true,
      isSlotRight: true
    })

    const language = computed(() => {
      return getRequestLanguage()
    })

    onMounted(() => {
      if (slots?.navLeft) {
        state.isSlotLeft = false
      } else {
        state.isSlotLeft = true
      }
      if (slots?.navRight) {
        state.isSlotRight = false
      } else {
        state.isSlotRight = true
      }
    })

    const handleClose = () => {
      props.onClose && props.onClose()
    }

    return {
      ...toRefs(state),
      handleClose,
      language
    }
  }
}
